<template>
  <div class="container">
    <div class="row">
      <div class="container">
        <div class="row mb-2">
          <div class="col">
            <label for="filterInput" class="sr-only">Filter table</label>
            <input id="filterInput"
                   v-model="filterInput"
                   type="search"
                   class="form-control"
                   aria-describedby="Filter"
                   placeholder="Filter...">
          </div>
          <div class="col text-center">
            <button type="button" class="btn btn-primary" v-on:click="reload">Reload</button>
          </div>
          <div class="col" />
        </div>
        <div class="row">
          <SortableTable v-if="tableAvailable"
                         :columns="columns"
                         :rows="filteredPosts"
                         class="col table-striped" />
          <PlaceHolderTable v-else
                            :columns="columns"
                            :row-num="5"
                            class="col" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SortableTable from './SortableTable'
  import PlaceHolderTable from './placeholder-loading/PlaceHolderTable'
  const nodeIndex = node => [...node.parentNode.children].indexOf(node)

  export default {
    components: {
      SortableTable,
      PlaceHolderTable
    },
    data() {
      return {
        columns: [
            {id: 'id', title: 'Post ID'},
            {id: 'userId', title: 'User ID'},
            {id: 'title', title: 'Title'},
        ],
        filterInput: '',
        posts: [],
        tableAvailable: false,
      }
    },
    computed: {
      filteredPosts: function () {
        if (this.filterInput.length > 2) {
          return this.posts.filter(post => post.title.toUpperCase().includes(this.filterInput.toUpperCase()))
        }
        return this.posts
      },
    },
    created() {
      this.reload()
    },
    methods: {
      reload() {
        this.tableAvailable = false
        this.posts = []
        fetch('https://jsonplaceholder.typicode.com/posts')
            .then(response => new Promise(resolve => setTimeout(() => resolve(response), 1000)))
            .then(response => response.json())
            .then(json => this.posts = json)
            .finally(() => this.tableAvailable = true)
      },
    },
  }
</script>


<style scoped>

</style>
